/* Use the theme's cart response for complete Shopify partner-pixel data. */
(() => {
  function init() {
    if (typeof window.theme?.AjaxProduct !== 'function') return;
    document.querySelectorAll('.rf-cart-form').forEach(form => {
      if (form.dataset.rfCartReady) return;
      const cart = new theme.AjaxProduct(form, '.rf-product-button');
      // The generic submit tracker lacks homepage product metadata. Let the
      // AJAX response supply it instead of sending a second, zero-value event.
      form.addEventListener('submit', event => {
        event.stopImmediatePropagation();
        cart.addItemFromForm(event);
      }, true);
      if (theme.settings.cartType !== 'drawer') {
        cart.success = () => { window.location.href = theme.routes.cartPage; };
      }
      form.dataset.rfCartReady = 'true';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
